<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-card-title style="background-color: #009688; color: white;">
                History for: &nbsp;<v-chip>{{ historyData.DIA_T }}</v-chip>
            </v-card-title>
            <v-card-text>
                <v-textarea
                    v-model="historyData.HISTORY"
                    readonly
                    label="History"
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="teal darken-1 white--text"
                    width="120"
                    @click="showDialog = false"
                >
                    <v-icon>{{ mdiClose }}</v-icon>
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {
    mdiClose
} from '@mdi/js'
export default {
    props: ['show', 'data'],
    data: ()=>({
        mdiClose,
        historyData: {
            DIA_T: null,
            HISTORY: null
        }
    }),
    computed: {
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        data(newVal) {
            this.historyData = structuredClone(newVal)
        }
    }
}
</script>
